module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/babel-runtime/~/core-js/library/modules/_add-to-unscopables.js
// module id = 1270
// module chunks = 0